/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User language
 */
export type Language = 'DE' | 'FR' | 'IT';

export const Language = {
    De: 'DE' as Language,
    Fr: 'FR' as Language,
    It: 'IT' as Language
};

